export default {
  methods: {
    handleError(e) {
      if (e.response) {
        if (e.response.data) {
          this.error = {
            status: e.response.status,
            err: e.response.data.error
          };
        } else {
          this.error = {
            status: e.response.status,
            err: true
          };
        }
      } else {
        this.error = {
          err: true,
          status: 500
        };
      }
    }
  }
};
